import React, { useState, useEffect } from 'react';
import MapController from '../../../../controllers/MapController';

const AnnotationLayer = ({ annotation }: { annotation: __esri.Graphic }) => {
  const [isVisible, setIsVisible] = useState(annotation.visible);

  useEffect(() => {
    if (annotation.visible !== isVisible) {
      MapController.toggleAnnotationVisibility(annotation.attributes.id, isVisible);
    }
  }, [isVisible, annotation]);

  return (
    <div className='layer-container'>
      <div className='layer annotation' key={annotation.attributes.id}>
        <div className='layer-title__wrapper'>
          <input
            type='checkbox'
            id={annotation.attributes.id}
            name={annotation.attributes.id}
            checked={isVisible}
            onChange={() => setIsVisible(!isVisible)}
          />
          <div className='layer-title'>{annotation.attributes.title}</div>
        </div>
        <div className='tools'>
          <span
            className='esri-icon-edit annotation-icon'
            onClick={() => MapController.editAnnotation(annotation.attributes.id)}
          />
          <span
            className='esri-icon-trash annotation-icon'
            onClick={() => MapController.deleteAnnotation(annotation.attributes.id)}
          />
        </div>
      </div>
    </div>
  )
};

export default AnnotationLayer;